import Vue from "vue";
import {
    createSession,
    getCode,
    getSessionsFromGroup,
    initFirebase,
    listenSessionsFromGroup,
    setSessionEndDate,
    setUserSecret,
    updateImageCountForSession
} from "../domain/domain";
import {
    anonymousSignin,
    getUrlParameter
} from "../domain/utils";

interface SessionData {
    [key: string]: {
        session_description: string,
        session_name: string,
        session_code: string,
        key: string
        session_end_date: number
        constellation_url: string
        constellation_simple_url: string
        session_open: boolean
        session_group: string
        image_count: number
    }
}


function randomCode() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

    for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

function randomCodeWithoutDuplicate(max_retries: number): Promise < string > {
    var code = randomCode();

    return new Promise(function (resolve, reject) {
        if (max_retries <= 0) {
            reject("Couldn't generate code");
            return;
        }

        getCode(code).then(_code_entry => {
            if (_code_entry === undefined) {
                resolve(code);
            } else {
                resolve(randomCodeWithoutDuplicate(max_retries - 1));
            }
        });
    })
}

export function sessionCreatePage() {
    initFirebase();

    var session_group = getUrlParameter("session_group");
    var secret = getUrlParameter("secret");
    var session_data: SessionData = {};

    var app = new Vue({
        el: "#app",
        data: {
            sessionGroupValid: false,
            sessionGroupInvalid: false,
            sessionGroup: "",

            sessionGroupName: "",
            sessionGroupDescription: "",

            sessionName: "",
            sessionDescription: "",
            sessionDuration: 30,

            sessions: session_data
        },
        methods: {
            updateImageCount: function() {
                Object.keys(app.sessions).forEach((session_id) => {
                    updateImageCountForSession(session_id);
                });
            },
            closeSession: function (session_id: string) {
                setSessionEndDate(session_group!, session_id, new Date().getTime());
            },

            doSubmitForm: function () {
                var session_name = this.sessionName;
                var session_description = this.sessionDescription;
                var session_duration = this.sessionDuration;
                var session_end_date = new Date().getTime() + session_duration * 60000;
                var key: string | null, code: string;

                randomCodeWithoutDuplicate(10).then(code => createSession(
                    session_group!,
                    session_name,
                    session_description,
                    session_end_date,
                    code
                )).catch(function (x) {
                    alert("Failure creating session: " + x);
                });
            },
        },
    });

    if (session_group && secret) {
        anonymousSignin().then((user) => setUserSecret(user.uid, secret!)).then(
            () => getSessionsFromGroup(session_group!)
        ).then(
            (sessions_by_group) => {
                app.sessionGroupValid = true;
                app.sessionGroupName = sessions_by_group.session_group_name;
                app.sessionGroupDescription = sessions_by_group.session_group_description;
            }
        ).then(() => {
            listenSessionsFromGroup(session_group!, sessions => {
                let data: SessionData = {};

                for (var key in sessions) {
                    data[key] = {
                        key: key,
                        session_name: sessions[key].session_name,
                        session_description: sessions[key].session_description,
                        session_code: sessions[key].session_code,
                        session_end_date: sessions[key].session_end_date,
                        constellation_url: new URL("viewer.html?session=" + key, document.baseURI).href,
                        constellation_simple_url: new URL("constellation-simple.html?session=" + key, document.baseURI).href,
                        session_open: sessions[key].session_end_date > Date.now(),
                        session_group: session_group!,
                        image_count: sessions[key].image_count
                    };
                }

                app.sessions = data;
            }, _error => {
                alert("004: Error loading page, please try again")
            })
        }).catch(function () {
            alert("004: Error loading page, please try again")
        });
    } else {
        app.sessionGroupValid = false;
        app.sessionGroupInvalid = true;
    }


}
